import React from 'react';
import { useNavigate } from 'react-router-dom';

function Hero({ data }) {
  const navigate = useNavigate();

  const handleAction = (action) => {
    const label = action.label.trim().toLowerCase();
    if (
      label === 'get a quote' ||
      label === 'get quote' ||
      label === 'book a demo' ||
      label === 'buy now' ||
      label === 'add to cart' ||
      label === 'get enquiry' ||
      label === 'submit enquiry' ||
      label === 'emergency repair'
    ) {
      navigate('/demo');
    } else if (label === 'view models') {
      navigate('/products');
    }
  };

  return (
    <header className="hero">
      <div className="hero-content">
        <p className="eyebrow">{data.eyebrow}</p>
        <h1>{data.title}</h1>
        <p className="hero-sub">{data.sub}</p>
        <div className="hero-actions">
          {data.actions.map((action) => (
            <button
              key={action.label}
              className={action.variant}
              onClick={() => handleAction(action)}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}

export default Hero;
